/* eslint-disable @typescript-eslint/no-non-null-assertion */
import vuexStore from '@/store'

import { Actions } from './index'

export const useLocaleActions = (store = vuexStore) => {
  const setCurrentLocale = (locale: string) => {
    store.dispatch(Actions.setCurrentLocale, locale)
  }

  const addLocale = (locale: string) => {
    store.dispatch(Actions.addLocale, locale)
  }

  const init = () => {
    return store.dispatch(Actions.init)
  }

  return {
    setCurrentLocale,
    addLocale,
    init,
  }
}
